export default __webpack_public_path__ + "static/media/n5.4fc87c20.png";